export const PROJECTS = [
  {
    "id": "project-scenes-demo",
    "slackUserId": "test-user",
    "title": "Multi Smooth Screen Intro",
    "subtitle": "Original Remotion project inspired by multi-panel motion",
    "badge": "HERMES x REMOTION",
    "durationSeconds": 10,
    "aspectRatio": "16:9",
    "background": "#101114",
    "accent": "#d8f36a",
    "scenes": [
      {
        "type": "intro",
        "headline": "Multi Smooth Screen",
        "subline": "Fast opener with layered panels",
        "layout": "split-panels"
      },
      {
        "type": "showcase",
        "headline": "Clean Motion System",
        "subline": "Soft transitions, bold type, modern rhythm",
        "layout": "three-panels"
      },
      {
        "type": "cta",
        "headline": "Ready To Render",
        "subline": "Edit in Studio, then export MP4",
        "layout": "center-cta"
      }
    ]
  },
  {
    "id": "project_1783575401291_9l6zzpuj",
    "slackUserId": "test-user",
    "slackChannelId": null,
    "title": "오늘의 회의 요약",
    "subtitle": "사용자별 프로젝트 테스트",
    "badge": "HERMES x REMOTION",
    "durationSeconds": 5,
    "aspectRatio": "16:9",
    "background": "#101114",
    "accent": "#d8f36a",
    "createdAt": "2026-07-09T05:36:41.291Z",
    "updatedAt": "2026-07-09T05:36:41.291Z",
    "lastRenderUrl": null
  },
  {
    "id": "project_1783575836125_jowlnkyp",
    "slackUserId": "U0BF5A63AN4",
    "slackChannelId": "D0BEQGCPZS7",
    "title": "Artlist 링크의 Multi Smooth Screen Intro 템플릿을 그대로 복제하지 않고, 다중 화면 패널과 부드러운 모션 전환에서 영감을 받은 오리지널 10초 16:9 Remotion 인트로 프로젝트",
    "subtitle": "Hermes Remotion Project",
    "badge": "HERMES x REMOTION",
    "durationSeconds": 10,
    "aspectRatio": "16:9",
    "background": "#101114",
    "accent": "#d8f36a",
    "createdAt": "2026-07-09T05:43:56.125Z",
    "updatedAt": "2026-07-09T05:44:53.784Z",
    "lastRenderUrl": null
  },
  {
    "id": "project_1783575951312_4jnf6zwo",
    "slackUserId": "U0BF5A63AN4",
    "slackChannelId": "D0BEQGCPZS7",
    "title": "Artlist Multi Smooth Screen Intro 템플릿의 분위기를 참고한 오리지널 Remotion 프로젝트: multi screen, smooth intro, split screen, modern clean typography, 10초, 16:9. 원본을 그대로 복제하지 않고 window/opener/intro/split-screen/slideshow/modern/clean/typography 태그에서 영감을 받은 독자적 구성.",
    "subtitle": "Hermes Remotion Project",
    "badge": "HERMES x REMOTION",
    "durationSeconds": 10,
    "aspectRatio": "16:9",
    "background": "#101114",
    "accent": "#d8f36a",
    "createdAt": "2026-07-09T05:45:51.312Z",
    "updatedAt": "2026-07-09T05:45:51.312Z",
    "lastRenderUrl": null
  },
  {
    "id": "project_1783576551616_4lklumgw",
    "slackUserId": "test-user",
    "slackChannelId": null,
    "title": "프로젝트별 스튜디오 테스트",
    "subtitle": "Studio Composition 자동 등록",
    "badge": "HERMES x REMOTION",
    "durationSeconds": 5,
    "aspectRatio": "16:9",
    "background": "#101114",
    "accent": "#d8f36a",
    "createdAt": "2026-07-09T05:55:51.615Z",
    "updatedAt": "2026-07-09T05:55:51.615Z",
    "lastRenderUrl": null
  },
  {
    "id": "project_1783577476723_3cb36ilv",
    "slackUserId": "U0BF5A63AN4",
    "slackChannelId": "D0BEQGCPZS7",
    "title": "Multi Smooth Screen Intro Inspired Original",
    "subtitle": "Hermes Remotion Project",
    "badge": "HERMES x REMOTION",
    "durationSeconds": 10,
    "aspectRatio": "16:9",
    "background": "#101114",
    "accent": "#d8f36a",
    "createdAt": "2026-07-09T06:11:16.722Z",
    "updatedAt": "2026-07-09T06:11:16.722Z",
    "lastRenderUrl": null
  },
  {
    "id": "project_1783580001615_sxj96rg7",
    "slackUserId": null,
    "slackChannelId": null,
    "title": "Reference Inspired Video",
    "subtitle": "Editable Remotion Studio project",
    "badge": "HERMES x REMOTION",
    "durationSeconds": 10,
    "aspectRatio": "16:9",
    "background": "#101114",
    "accent": "#d8f36a",
    "createdAt": "2026-07-09T06:53:21.615Z",
    "updatedAt": "2026-07-09T06:53:21.615Z",
    "lastRenderUrl": null
  },
  {
    "id": "project_1783580139588_unzkg3iy",
    "slackUserId": null,
    "slackChannelId": null,
    "title": "Reference Inspired Video",
    "subtitle": "Editable Remotion Studio project",
    "badge": "HERMES x REMOTION",
    "durationSeconds": 10,
    "aspectRatio": "16:9",
    "background": "#101114",
    "accent": "#d8f36a",
    "scenes": [
      {
        "type": "opener",
        "headline": "SMOOTH INTRO",
        "subline": "multi screen motion opener",
        "layout": "split-panels"
      },
      {
        "type": "transition",
        "headline": "SCREEN FLOW",
        "subline": "soft sliding windows and layered masks",
        "layout": "three-panels"
      },
      {
        "type": "showcase",
        "headline": "CLEAN TYPOGRAPHY",
        "subline": "minimal titles with modern spacing",
        "layout": "split-panels"
      },
      {
        "type": "closing",
        "headline": "YOUR STORY STARTS",
        "subline": "original intro inspired by smooth screen transitions",
        "layout": "center-cta"
      }
    ],
    "referenceUrl": "https://artlist.io/video-templates/multi-smooth-screen-intro/112257",
    "prompt": "https://artlist.io/video-templates/multi-smooth-screen-intro/112257 이 링크를 참고해서 원본을 그대로 복제하지 말고 멀티 스크린 인트로 느낌의 편집 가능한 Remotion 프로젝트를 만들어줘",
    "mode": "reference-inspired",
    "settings": {
      "durationMode": "follow-reference",
      "aspectRatioMode": "follow-reference",
      "resolutionMode": "auto",
      "sceneCountMode": "follow-reference",
      "durationSeconds": 10,
      "aspectRatio": "16:9",
      "width": 1280,
      "height": 720,
      "fps": 30,
      "sceneCount": 4,
      "styleStrength": "medium"
    },
    "width": 1280,
    "height": 720,
    "fps": 30,
    "createdAt": "2026-07-09T06:55:39.588Z",
    "updatedAt": "2026-07-09T06:55:39.588Z",
    "lastRenderUrl": null
  },
  {
    "id": "project_1783580675580_v276pmmn",
    "slackUserId": null,
    "slackChannelId": null,
    "title": "Reference Inspired Video",
    "subtitle": "Editable Remotion Studio project",
    "badge": "HERMES x REMOTION",
    "durationSeconds": 10,
    "aspectRatio": "16:9",
    "background": "#101114",
    "accent": "#d8f36a",
    "scenes": [
      {
        "type": "opener",
        "headline": "SMOOTH INTRO",
        "subline": "multi screen motion opener",
        "layout": "split-panels"
      },
      {
        "type": "transition",
        "headline": "SCREEN FLOW",
        "subline": "soft sliding windows and layered masks",
        "layout": "three-panels"
      },
      {
        "type": "showcase",
        "headline": "CLEAN TYPOGRAPHY",
        "subline": "minimal titles with modern spacing",
        "layout": "split-panels"
      },
      {
        "type": "closing",
        "headline": "YOUR STORY STARTS",
        "subline": "original intro inspired by smooth screen transitions",
        "layout": "center-cta"
      }
    ],
    "referenceUrl": "https://artlist.io/video-templates/multi-smooth-screen-intro/112257",
    "prompt": "Artlist Multi Smooth Screen Intro reference link를 참고해서 원본을 그대로 복제하지 말고, 구조/무드/전환감/색감/타이포만 참고한 오리지널 편집 가능한 Remotion Studio 프로젝트를 만들어줘. 멀티 스크린 인트로 느낌. 길이와 비율은 참고 영상처럼.",
    "mode": "reference-inspired",
    "settings": {
      "durationMode": "follow-reference",
      "aspectRatioMode": "follow-reference",
      "resolutionMode": "auto",
      "sceneCountMode": "follow-reference",
      "durationSeconds": 10,
      "aspectRatio": "16:9",
      "width": 1280,
      "height": 720,
      "fps": 30,
      "sceneCount": 4,
      "styleStrength": "medium"
    },
    "width": 1280,
    "height": 720,
    "fps": 30,
    "createdAt": "2026-07-09T07:04:35.580Z",
    "updatedAt": "2026-07-09T07:04:35.580Z",
    "lastRenderUrl": null
  },
  {
    "id": "project_1783580840577_7wje64os",
    "slackUserId": null,
    "slackChannelId": null,
    "title": "Reference Inspired Video",
    "subtitle": "Editable Remotion Studio project",
    "badge": "HERMES x REMOTION",
    "durationSeconds": 10,
    "aspectRatio": "16:9",
    "background": "#101114",
    "accent": "#d8f36a",
    "scenes": [
      {
        "type": "opener",
        "headline": "SMOOTH INTRO",
        "subline": "multi screen motion opener",
        "layout": "split-panels"
      },
      {
        "type": "transition",
        "headline": "SCREEN FLOW",
        "subline": "soft sliding windows and layered masks",
        "layout": "three-panels"
      },
      {
        "type": "showcase",
        "headline": "CLEAN TYPOGRAPHY",
        "subline": "minimal titles with modern spacing",
        "layout": "split-panels"
      },
      {
        "type": "closing",
        "headline": "YOUR STORY STARTS",
        "subline": "original intro inspired by smooth screen transitions",
        "layout": "center-cta"
      }
    ],
    "referenceUrl": "https://artlist.io/video-templates/multi-smooth-screen-intro/112257",
    "prompt": "https://artlist.io/video-templates/multi-smooth-screen-intro/112257 이 링크를 참고해서 원본을 그대로 복제하지 말고 멀티 스크린 인트로 느낌의 편집 가능한 Remotion 프로젝트를 만들어줘",
    "mode": "reference-inspired",
    "settings": {
      "durationMode": "follow-reference",
      "aspectRatioMode": "follow-reference",
      "resolutionMode": "auto",
      "sceneCountMode": "follow-reference",
      "durationSeconds": 10,
      "aspectRatio": "16:9",
      "width": 1280,
      "height": 720,
      "fps": 30,
      "sceneCount": 4,
      "styleStrength": "medium"
    },
    "width": 1280,
    "height": 720,
    "fps": 30,
    "createdAt": "2026-07-09T07:07:20.577Z",
    "updatedAt": "2026-07-09T07:08:18.031Z",
    "lastRenderUrl": "https://remotion-render.srv1801288.hstgr.cloud/renders/render_1783580840584_fqicu9k3.mp4"
  },
  {
    "id": "project_1783639886802_j7mqv214",
    "slackUserId": "U_TEST",
    "slackChannelId": "C_TEST",
    "slackThreadTs": null,
    "title": "Generated Remotion Project",
    "subtitle": "Editable Remotion Studio project",
    "badge": "HERMES x REMOTION",
    "durationSeconds": 10,
    "aspectRatio": "16:9",
    "background": "#101114",
    "accent": "#d8f36a",
    "scenes": [
      {
        "type": "intro",
        "headline": "NEW VIDEO PROJECT",
        "subline": "AI generated Remotion direction",
        "layout": "split-panels"
      },
      {
        "type": "showcase",
        "headline": "VISUAL SYSTEM",
        "subline": "structured motion and typography",
        "layout": "three-panels"
      },
      {
        "type": "story",
        "headline": "CLEAR MESSAGE",
        "subline": "edited in Remotion Studio",
        "layout": "split-panels"
      },
      {
        "type": "cta",
        "headline": "READY TO EDIT",
        "subline": "preview, adjust, render",
        "layout": "center-cta"
      }
    ],
    "referenceUrl": null,
    "prompt": "회사 소개용 10초 테스트 영상 만들어줘",
    "mode": "ai-recommended",
    "settings": {
      "durationMode": "custom",
      "aspectRatioMode": "custom",
      "resolutionMode": "auto",
      "sceneCountMode": "auto",
      "durationSeconds": 10,
      "aspectRatio": "16:9",
      "width": 1280,
      "height": 720,
      "fps": 30,
      "sceneCount": 4,
      "styleStrength": "medium"
    },
    "width": 1280,
    "height": 720,
    "fps": 30,
    "createdAt": "2026-07-09T23:31:26.803Z",
    "updatedAt": "2026-07-13T03:49:10.412Z",
    "lastRenderUrl": "https://remotion-render.srv1801288.hstgr.cloud/renders/import_1783914550406_acf96011.mp4"
  },
  {
    "id": "project_1784099567717_dcdfeipv",
    "slackUserId": "1526749835259285714",
    "slackChannelId": null,
    "slackThreadTs": null,
    "title": "E2E-개구리",
    "subtitle": "Editable Remotion Studio project",
    "badge": "HERMES x REMOTION",
    "durationSeconds": 10,
    "aspectRatio": "16:9",
    "background": "#101114",
    "accent": "#d8f36a",
    "scenes": [
      {
        "type": "intro",
        "headline": "NEW VIDEO PROJECT",
        "subline": "AI generated Remotion direction",
        "layout": "split-panels"
      },
      {
        "type": "showcase",
        "headline": "VISUAL SYSTEM",
        "subline": "structured motion and typography",
        "layout": "three-panels"
      },
      {
        "type": "story",
        "headline": "CLEAR MESSAGE",
        "subline": "edited in Remotion Studio",
        "layout": "split-panels"
      },
      {
        "type": "cta",
        "headline": "READY TO EDIT",
        "subline": "preview, adjust, render",
        "layout": "center-cta"
      }
    ],
    "referenceUrl": null,
    "prompt": "Create a 3-second silent 1:1 Remotion video titled “E2E-개구리”. The visual should use a single simple centered green frog icon on a transparent or very light background. The frog icon must be the only main artwork: round green face/body, two big eyes, small smile, cute flat vector/icon style. Animation: fade in only from opacity 0 to 1 during the first ~0.8 seconds; after that remain still. No audio, no camera movement, no text overlays.",
    "mode": "prompt-inspired",
    "settings": {
      "durationMode": "auto",
      "aspectRatioMode": "auto",
      "resolutionMode": "auto",
      "sceneCountMode": "auto",
      "durationSeconds": 10,
      "aspectRatio": "16:9",
      "width": 1280,
      "height": 720,
      "fps": 30,
      "sceneCount": 4,
      "styleStrength": "medium"
    },
    "width": 1280,
    "height": 720,
    "fps": 30,
    "createdAt": "2026-07-15T07:12:47.718Z",
    "updatedAt": "2026-07-15T07:12:47.718Z",
    "lastRenderUrl": null
  },
  {
    "id": "project_1784099659995_xylqmi94",
    "slackUserId": "1526749835259285714",
    "slackChannelId": null,
    "slackThreadTs": null,
    "title": "E2E-개구리",
    "subtitle": "Editable Remotion Studio project",
    "badge": "HERMES x REMOTION",
    "durationSeconds": 10,
    "aspectRatio": "16:9",
    "background": "#101114",
    "accent": "#d8f36a",
    "scenes": [
      {
        "type": "intro",
        "headline": "NEW VIDEO PROJECT",
        "subline": "AI generated Remotion direction",
        "layout": "split-panels"
      },
      {
        "type": "showcase",
        "headline": "VISUAL SYSTEM",
        "subline": "structured motion and typography",
        "layout": "three-panels"
      },
      {
        "type": "story",
        "headline": "CLEAR MESSAGE",
        "subline": "edited in Remotion Studio",
        "layout": "split-panels"
      },
      {
        "type": "cta",
        "headline": "READY TO EDIT",
        "subline": "preview, adjust, render",
        "layout": "center-cta"
      }
    ],
    "referenceUrl": null,
    "prompt": "Create a 3-second silent 1:1 Remotion video titled “E2E-개구리”. Use a single simple green frog icon centered on a pale background, matching this SVG-style asset: rounded green frog face/body, two large eyes, small smile, flat vector icon. Animation must be fade-in only: opacity 0 at frame 0 to opacity 1 by about 0.8 seconds, then completely still until the end. No audio, no text overlays, no camera movement, no other animations.",
    "mode": "prompt-inspired",
    "settings": {
      "durationMode": "auto",
      "aspectRatioMode": "auto",
      "resolutionMode": "auto",
      "sceneCountMode": "auto",
      "durationSeconds": 10,
      "aspectRatio": "16:9",
      "width": 1280,
      "height": 720,
      "fps": 30,
      "sceneCount": 4,
      "styleStrength": "medium"
    },
    "width": 1280,
    "height": 720,
    "fps": 30,
    "createdAt": "2026-07-15T07:14:19.995Z",
    "updatedAt": "2026-07-15T08:09:53.572Z",
    "lastRenderUrl": "https://remotion-render.srv1801288.hstgr.cloud/renders/render_1784102936782_iy8ns4ga.mp4"
  },
  {
    "id": "project_1784103514182_ss46xha2",
    "slackUserId": "1526749835259285714",
    "slackChannelId": null,
    "slackThreadTs": null,
    "title": "E2E-개구리",
    "subtitle": "Editable Remotion Studio project",
    "badge": "HERMES x REMOTION",
    "durationSeconds": 10,
    "aspectRatio": "16:9",
    "background": "#101114",
    "accent": "#d8f36a",
    "scenes": [
      {
        "type": "intro",
        "headline": "NEW VIDEO PROJECT",
        "subline": "AI generated Remotion direction",
        "layout": "split-panels"
      },
      {
        "type": "showcase",
        "headline": "VISUAL SYSTEM",
        "subline": "structured motion and typography",
        "layout": "three-panels"
      },
      {
        "type": "story",
        "headline": "CLEAR MESSAGE",
        "subline": "edited in Remotion Studio",
        "layout": "split-panels"
      },
      {
        "type": "cta",
        "headline": "READY TO EDIT",
        "subline": "preview, adjust, render",
        "layout": "center-cta"
      }
    ],
    "referenceUrl": null,
    "prompt": "Create a 3-second silent square (1:1) Remotion video titled “E2E-개구리”. Use exactly one simple centered green frog icon on a pale background: cute flat vector style, rounded green frog face/body, two large eyes, small smile. Animation: fade in only, from opacity 0 at frame 0 to opacity 1 by 0.8 seconds, then remain completely still until the end. No audio, no text overlays, no camera movement, no other animation.",
    "mode": "prompt-inspired",
    "settings": {
      "durationMode": "auto",
      "aspectRatioMode": "auto",
      "resolutionMode": "auto",
      "sceneCountMode": "auto",
      "durationSeconds": 10,
      "aspectRatio": "16:9",
      "width": 1280,
      "height": 720,
      "fps": 30,
      "sceneCount": 4,
      "styleStrength": "medium"
    },
    "width": 1280,
    "height": 720,
    "fps": 30,
    "createdAt": "2026-07-15T08:18:34.182Z",
    "updatedAt": "2026-07-16T00:53:08.061Z",
    "lastRenderUrl": "https://remotion-render.srv1801288.hstgr.cloud/renders/render_1784163141196_u6ngsejg.mp4"
  },
  {
    "id": "project_1785635020249_28gr9rm1",
    "slackUserId": null,
    "slackChannelId": null,
    "slackThreadTs": null,
    "title": "StoryFlow Remotion smoke 20260802",
    "subtitle": "20-user readiness",
    "badge": "HERMES x REMOTION",
    "durationSeconds": 1,
    "aspectRatio": "16:9",
    "background": "#101114",
    "accent": "#d8f36a",
    "scenes": [
      {
        "type": "intro",
        "headline": "StoryFlow",
        "subline": "Remotion test",
        "layout": "center-cta"
      }
    ],
    "referenceUrl": null,
    "prompt": "",
    "mode": null,
    "settings": null,
    "width": 640,
    "height": 360,
    "fps": 24,
    "createdAt": "2026-08-02T01:43:40.249Z",
    "updatedAt": "2026-08-02T01:44:05.910Z",
    "lastRenderUrl": "https://remotion-render.srv1801288.hstgr.cloud/renders/render_1785635020260_qylq27y9.mp4"
  },
  {
    "id": "project_1787687029524_n92ykr4t",
    "slackUserId": null,
    "slackChannelId": null,
    "slackThreadTs": null,
    "title": "수업용 720p 성능 검증",
    "subtitle": "Hermes Remotion Project",
    "badge": "HERMES x REMOTION",
    "durationSeconds": 3,
    "aspectRatio": "9:16",
    "background": "#101114",
    "accent": "#d8f36a",
    "scenes": [
      {
        "headline": "720P CLASS TEST",
        "subline": "render capacity check"
      }
    ],
    "referenceUrl": null,
    "prompt": "",
    "mode": null,
    "settings": null,
    "width": 1080,
    "height": 1920,
    "fps": 30,
    "createdAt": "2026-08-25T19:43:49.523Z",
    "updatedAt": "2026-08-25T19:44:06.747Z",
    "lastRenderUrl": "https://remotion-render.srv1801288.hstgr.cloud/renders/render_1787687029533_y027o1sj.mp4"
  },
  {
    "id": "project_1787687107940_dt1u0kwt",
    "slackUserId": null,
    "slackChannelId": null,
    "slackThreadTs": null,
    "title": "수업용 720p 성능 검증",
    "subtitle": "Hermes Remotion Project",
    "badge": "HERMES x REMOTION",
    "durationSeconds": 3,
    "aspectRatio": "9:16",
    "background": "#101114",
    "accent": "#d8f36a",
    "scenes": [
      {
        "headline": "720P CLASS TEST",
        "subline": "render capacity check"
      }
    ],
    "referenceUrl": null,
    "prompt": "",
    "mode": null,
    "settings": null,
    "width": 1080,
    "height": 1920,
    "fps": 30,
    "createdAt": "2026-08-25T19:45:07.940Z",
    "updatedAt": "2026-08-25T19:45:25.235Z",
    "lastRenderUrl": "https://remotion-render.srv1801288.hstgr.cloud/renders/render_1787687107947_fe5ic5h2.mp4"
  }
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
